import { render, staticRenderFns } from "./YouPlusProductCategory.vue?vue&type=template&id=0f880506&scoped=true"
import script from "./YouPlusProductCategory.vue?vue&type=script&lang=js"
export * from "./YouPlusProductCategory.vue?vue&type=script&lang=js"
import style0 from "./YouPlusProductCategory.vue?vue&type=style&index=0&id=0f880506&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f880506",
  null
  
)

export default component.exports